import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
  inject,
  input,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DatePickerComponent } from '@groundworks/ngx-groundworks-ui';
import {
  NgMultiLabelTemplateDirective,
  NgSelectComponent,
} from '@ng-select/ng-select';
import { BranchInfo } from '../../sdk/sdk';
import { ConfigService } from '../../config.service';
import { formatIsoToDisplay, parseLocalIsoDate } from '../../utils/iso-date';
import { TravelAssignmentsStore } from './travel-assignments-store.service';

@Component({
  selector: 'app-foreman-travel-lines',
  templateUrl: './foreman-travel-lines.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [
    DatePickerComponent,
    NgSelectComponent,
    NgMultiLabelTemplateDirective,
    NgTemplateOutlet,
    FormsModule,
  ],
})
export class ForemanTravelLinesComponent {
  protected readonly travelStore = inject(TravelAssignmentsStore);
  protected readonly configService = inject(ConfigService);

  readonly foremanUserId = input.required<string>();
  readonly availableBranches = input.required<BranchInfo[]>();

  protected readonly visibleLines = this.travelStore.visibleLines;
  protected readonly hasNoVisibleLines = this.travelStore.hasNoVisibleLines;
  protected readonly formatDateForDisplay = formatIsoToDisplay;
  protected readonly parseIsoDate = parseLocalIsoDate;

  handleDate(lineKey: number, field: 'startDate' | 'endDate', date: Date | null): void {
    this.travelStore.handleDate(lineKey, field, date, this.foremanUserId());
  }

  onCrewDropdownOpen(lineKey: number): void {
    this.travelStore.onCrewDropdownOpen(lineKey, this.foremanUserId());
  }
}
